const initialState = {
    user: null,
    userId: null,
    error: null,
    isAuthenticated: false
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                user: action.payload,
                userId: action.payload.id,
                error: null,
                isAuthenticated: true
            };
        case 'LOGIN_FAILURE':
            return {
                ...state,
                user: null,
                userId: null,
                error: action.payload,
                isAuthenticated: false
            };
        case 'LOGOUT':
            return {
                ...state,
                user: null,
                userId: null,
                error: null,
                isAuthenticated: false
            };
        default:
            return state;
    }
};

export default authReducer;
